import { Building } from 'lucide-react';
import { useSEO, localKeywords } from '@/hooks/useSEO';
import './References.css';

export default function References() {
  useSEO({
    title: 'Referanslar | Mayi Mimarlık Diyarbakır — Tamamlanan Projeler',
    description:
      "Diyarbakır ve Güneydoğu Anadolu'da Mayi Mimarlık'ın seramik, vitrifiye ve yapı malzemesi tedarik ettiği referans projeler ve iş ortakları.",
    keywords: localKeywords(
      'mayi mimarlık referanslar',
      'diyarbakır inşaat projeleri seramik',
      'güneydoğu anadolu yapı malzemeleri projeleri'
    ),
    canonical: 'https://mayimimarlik.com/referanslar',
  });

  const references = [
    "AZOR YAPI", "MED A.Ş", "PİA YAPI", "KAİZEN İNŞAAT", "ARBEK MAKİNA",
    "ÇETİNLER DİYARLAND İNŞAAT", "KARAYIL İNŞAAT", "GO PETROL", "BEDİR YAPI",
    "ANEMON OTEL", "TAŞKIN YAPI", "MEPA OTOMOTİV", "ORTADOĞU KOLEJİ",
    "ZANA YAPI", "ÖZALTINSOY İNŞAAT", "TARHAN İNŞAAT", "ASMİR YAPI", "STAR YAPI",
    "DURMAZ İNŞAAT", "NF MÜHENDİSLİK", "RÜZGAR KOLEJİ", "KUTAY İNŞAAT",
    "SİYABEND İNŞAAT", "ELBEY İNŞAAT", "AR YAPI", "KAYASAN İNŞAAT",
    "WELAT YAPI", "LİVİA YAPI", "BY MEN YAPI", "KULE CİTY İNŞAAT", "TEPE YAPI",
    "OĞUR YAPI", "ÇEYSA SİN İNŞAAT", "CENTROPOL İNŞAAT", "ÇEYSA YAPI",
    "KAPLAN İNŞAAT", "AY YAPI", "PARMA YAPI"
  ];

  return (
    <div className="page-container" style={{ paddingTop: 'calc(var(--header-height) + var(--spacing-3xl))', paddingBottom: 'var(--spacing-4xl)', minHeight: '80vh' }}>
      <div className="container">
        <h1 className="text-4xl mb-md">Projeler & Referanslar</h1>
        <div className="section-divider mb-xl"></div>
        <p className="text-secondary max-w-2xl mb-xl">
          Tasarımdan uygulamaya, mimari vizyonun gerçeğe dönüştüğü prestijli projelerimiz. Sektöründe öncü kurumlar ile gerçekleştirdiğimiz başarılı çalışmalar. 
        </p>
        
        <div className="references-grid">
          {references.map((ref, idx) => (
            <div key={idx} className="reference-card glass animate-fade-in" style={{ animationDelay: `${idx * 0.02}s` }}>
              <div className="reference-icon">
                <Building size={20} className="text-accent" />
              </div>
              <h3 className="reference-name font-medium">{ref}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
